import Icon from 'vue-awesome/components/Icon'

Icon.register({
  near_me_two_tone: {
    paths: [
      {
        opacity: '.3',
        d: 'M11.39 12.61l.32.83 1.32 3.42 4.24-10.13-10.13 4.24 3.42 1.33z'
      },
      {
        d: 'M3 11.51l6.84 2.65L12.48 21h.98L21 3 3 10.53v.98zm14.27-4.78l-4.24 10.13-1.32-3.42-.32-.83-.82-.32-3.43-1.33 10.13-4.23z'
      }
    ],
    width: '24',
    height: '24'
  }
})
